/** @format */

import { ResourceReference } from "../../../types";
import { QueryProps } from "../resourceIndexUI/ResourcesIndexUI";

export const filterResources = (
  resources: ResourceReference[],
  filterName: string,
  query: QueryProps,
): ResourceReference[] => {
  const { types, tags, level, specItem, qualification, cats, status } = query;
  const filteredResources = resources.filter(
    (resource) =>
      (filterName === "types" ||
        types.length === 0 ||
        types.includes(resource.Type)) &&
      (filterName === "tags" ||
        tags.length === 0 ||
        Array.from(new Set(resource.Object.tags)).filter((rTag) =>
          tags.find(
            (tag) =>
              tag.toLocaleLowerCase().trim() ===
              rTag.toLocaleLowerCase().trim(),
          ),
        ).length === tags.length) &&
      (filterName === "level" ||
        !level ||
        (Array.isArray(resource.Object.levels) &&
          resource.Object.levels?.includes(level))) &&
      (filterName === "spec" ||
        !specItem ||
        (resource.SpecItem &&
          resource.SpecItem.startsWith(specItem) &&
          resource.Qualification === qualification)) &&
      (filterName === "qualification" ||
        !qualification ||
        resource.Qualification === qualification) &&
      (filterName === "cats" ||
        cats.length === 0 ||
        Array.from(new Set(resource.Object?.categories)).filter((rCat) =>
          cats.includes(rCat),
        ).length > 0) &&
      (filterName === "status" || !status || resource.Status === status),
  );

  return filteredResources;
};
